function isKeyInvalidValidationReduxUtil (validation, key) {
  if (!validation || validation === true) {
    return false
  }
  return validation.key === key
}

export default isKeyInvalidValidationReduxUtil
